__webpack_require__.p = "/getlokker/";